import { useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';
import { sharedSequenceStateManager } from '../game/managers/SharedSequenceStateManager';
import { parseSequenceId } from '@/lib/sequenceUtils';

/**
 * Component that listens for shared sequence events and shows notifications
 */
export function SharedSequenceNotification() {
  const { toast } = useToast();

  useEffect(() => {
    const handleSharedSequenceLoaded = (event: CustomEvent) => {
      const { sequenceId, date } = event.detail;
      
      // Format the date nicely for display
      const formattedDate = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
      
      toast({
        title: "🎲 Playing Shared Challenge",
        description: `Loading practice sequence from ${formattedDate}`,
        duration: 4000,
      });
    };

    // Listen for shared sequence events
    window.addEventListener('babblegram_shared_sequence_loaded', handleSharedSequenceLoaded as EventListener);

    // Subscribe to shared sequence state changes
    const unsubscribe = sharedSequenceStateManager.subscribe((state) => {
      if (state.isActive && state.sequenceId && !state.isProcessing) {
        // Show notification when shared sequence becomes active
        try {
          const date = parseSequenceId(state.sequenceId);
          const formattedDate = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });
          
          toast({
            title: "🎲 Playing Shared Challenge",
            description: `Loading practice sequence from ${formattedDate}`,
            duration: 4000,
          });
        } catch (error) {
          console.warn('Could not parse sequence ID for notification:', error);
          toast({
            title: "🎲 Playing Shared Challenge",
            description: "Loading shared practice sequence",
            duration: 4000,
          });
        }
      }
    });

    return () => {
      window.removeEventListener('babblegram_shared_sequence_loaded', handleSharedSequenceLoaded as EventListener);
      unsubscribe();
    };
  }, [toast]);

  return null; // This component only handles notifications
}